import { CnRequestConfig, request } from 'cn-request';
import { CnMessage } from '@cainiaofe/cn-ui';
import { getRealResponse } from '../util/util';
import {
  DqiItem,
  DqiParam,
} from '@/lowcode/common/setter/components/drag-item/types';
import {
  getDataEasyUrl,
  handleSuccessMessage,
} from '@/lowcode/common/request/requestUtil';

interface Res<T> {
  data?: T;
  errorCode?: string;
  errorMsg?: string;
  msg?: string;
  success: boolean;
}

interface DataEasyRes {
  records?: Record<string, unknown>;
  paging?: {
    totalCount: number;
    currentPage: number;
    pageSize: number;
  };
}

// 查询指定数据集数据
export const queryData = async (
  config: CnRequestConfig,
  handleResponse?: (res: unknown) => unknown,
  needSuccessToast?: boolean,
) => {
  try {
    const res = await request(config);
    const result = handleResponse ? handleResponse(res) : res;
    const { success, errorCode, errorMsg } = result as Res<DataEasyRes>;

    if (success) {
      if (needSuccessToast) {
        handleSuccessMessage(result);
      }
      return result;
    }
    CnMessage.error(errorMsg || errorCode || `${config?.url} 请求异常`);
    return null;
  } catch (err) {
    return null;
  }
};

// 查询数据集元数据，仅在研发态调用
export const queryDataSetDetailByIdPath = async (serviceCode: string) => {
  try {
    const config = {
      url: getDataEasyUrl('/dataeasy/data-service/metadata', true),
      method: 'get',
      withCredentials: true,
      params: {
        serviceCode,
      },
    };

    const res = await request({
      url: getDataEasyUrl('/dataeasy/data-service/metadata', true),
      method: 'get',
      withCredentials: true,
      params: {
        serviceCode,
      },
    });

    const { data } = getRealResponse(res) as Res<{
      results: DqiItem[];
      params: DqiParam[];
    }>;

    return data?.results || [];
  } catch {
    return [];
  }
};
